import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./StatusBadge.module.scss";
const STATUS_CONFIG = {
    Up: { label: "Up", icon: "●", className: styles.up },
    Down: { label: "Down", icon: "●", className: styles.down },
    Unknown: { label: "Unknown", icon: "○", className: styles.unknown },
};
export function StatusBadge({ status, title }) {
    const config = STATUS_CONFIG[status];
    return (_jsxs("span", { className: `${styles.badge} ${config.className}`, title: title, children: [_jsx("span", { "aria-hidden": "true", children: config.icon }), config.label] }));
}
